/* eslint-disable */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Navbar, Nav, Alert } from "react-bootstrap";
import { bindActionCreators } from "redux";
import axios from "axios";
import PhoneFooter from "./PhoneFooter";
import "../agent/Styles/darktheme.css";
import "../agent/Styles/blacktheme.css";
import "../agent/Styles/highContrast.css";
import MfaModal from "../popups/MfaModal"; 

import {
  getAgentTokenData,
  getAgentConfigAndInfo,
  getAgents,
  getAllAgents,
  updateAgentsCallAvailability,
  getSupervisors,
  agentOnCall,
  agentOnCallAnswered,
  agentCallTerminated,
  changeLang,
  doLogout,
  setAgentsOnCallList,
  setAgentConfigData,
  setAgentPermission,
  getInitialAgentConfigAndInfo,
  setLanguageBackend,
  getAgentInfo,
} from "../actions/getAgentConfig";
import {
  addCallEvent,
  outgoingTerminated,
  incomingTerminated,
  incomingMissed,
  queueCallJoin,
  queueCallLeave,
  queueCallNoAnswer,
  modifyQueueCalls,
  getCallUrl,
  fullScreenChange,
  callStarted,
  callAnswered,
  setTabLock,
  deleteCallEvent,
  setResetActiveTab,
  makeOutgoingCall,
  resetCall,
  setCallUrlData,
  deleteCallEvents,
  removeNotification,
  notificationOpened,
  showWebphone,
} from "../actions/call";
import {
  getOutgoingCalls,
  getIncomingCalls,
  getAuotoDialerCalls,
  getQueuedCalls,
} from "../actions/getCalls";
import {
  getAvailabilityList,
  setCallAvailability,
  changeDefaultAvailability,
  setOnline,
} from "../actions/availability";
import {
  getServicesListByAgent,
  setDefaultService,
} from "../actions/outgoingService";
import { slackNotification } from "../actions/errorNotification";
import {
  closeMenuPopup,
  getCustomLogo,
  set_thememode,
  set_theme,
  get_theme,
  set_themecode,
  getOmniUrl,
  setAudioSettings,
  set_showInvalidAudioSettingsMessage
} from "../actions/common";
import {
  addOutgoingCall,
  removeOutgoingCall,
  updateOutgoingCall,
} from "../actions/outgoingCalls";
import {
  addIncomingCall,
  removeIncomingCall,
} from "../actions/incomingCallsList";
import {
  setItem,
  getItem,
  removeItem,
  setStorageItem,
  removeStorageItem,
} from "../utils/storage";
import {
  getParameterByName,
  filterUrl,
  filterPhoneNumber,
  getUniqueCalls,
  toastErrorMsg,
  logData,
  setDebug,
  getWebPhoneDomain,
} from "../utils/utils";

import numintecLogo from "../assets/img/logo-navbar.svg";
import UserMenu from "./user-menu.js";
import TabMenu from "./tabs.js";
import NotificationMenu from "./notification-menu.js";
import HeaderSearch from "./HeaderSearch.js";
import AgentHeaderSearch from "./AgentHeaderSearch.js";
import TelephonePanel from "./telephone-panel";
import QueuePanel from "./queue-panel.js";
import OutgoingPanel from "./outgoing-panel.js";
import AgentPanel from "./agent-panel.js";
import IncomingPanel from "./incoming-panel.js";
import AutomotivePanel from "./automotive-panel.js";
import Runtime from "./Runtime.js";
import AgentsMonitor from "./AgentsMonitor.js";
import Notifications from "./Notifications";
import AvailabilityModal from "./modals/availability";
import AskForService from "./modals/AskForService";
import moment from "moment-timezone";
import Loader from "./Components/Loader";
import "react-toastify/dist/ReactToastify.min.css";
import "./tabs.css";
import { availableLanguages } from "../translations";
import { setApiDomain, getApiDomain } from "./config";
import { checkLogin, handleLogoutRedirect } from "../utils/authutils";
import {
  customGetAgentCred,
  customGetConnectionToken,
  customGetUserProperties,
} from "../utils/apihelpers";

let popupLink = "";

const PANELS = "panels";
const BROWSER = "browser";
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      websiteUrl: window.location.href,
      showAvailabilityModal: false,
      showModal: true,
      components: {
        telephony: TelephonePanel,
        calls_in_queue: QueuePanel,
        agent: AgentPanel,
        incoming_calls: IncomingPanel,
        autodialer: AutomotivePanel,
        outgoing_calls: OutgoingPanel,
      },
      
      agentSearch: "",
      panels_order: [],
      ignorePanels: [],
      listenerConnected: false,
      fullScreen: false,
      activeMonitorView: "AgentsMonitorWithService",
      onGoingCallData: {},
      showOfflineAlert: !navigator.onLine,
      selectedContent: PANELS,
      isAgentConfigUpdated: false,
      isReloaded: false,
      connectiontoken: "",
      properties: {}
    };
    this.incomingCallist = [];
    this.outgoingCallist = [];
    this.currentActiveTabs = [];
  }

  deviceIsAllowed = (device_id, device_data_list) => {

    let device_allowed = false;

    if (device_id === "")
    {
        device_allowed = true;
    }
    else
    {
        device_data_list.forEach( (device_data) => {
    
          // console.log('Device data: ', device_data.deviceId);
          // console.log('Devices id: ', device_id);
    
          if (device_data.deviceId === device_id)
          {
            device_allowed = true;
          }
    
        });
    }
    return device_allowed;

  }


  postLogin = async (hadToken) => {
    const { agent_data, agent_status } = await customGetAgentCred();
    const agent_id = agent_data.agent_id;
    const extension = agent_data.extension;
    const username = agent_data.username;
    // persist agent email so MfaModal can read it via localStorage.getItem('email')
    if (agent_data && agent_data.email) {
      localStorage.setItem("email", agent_data.email);
    } else if (agent_data && agent_data.username) {
      // fallback if email not present
      localStorage.setItem("email", agent_data.username);
    }
    localStorage.setItem("agent_id", agent_id);
    localStorage.setItem("extension", extension);
    localStorage.setItem("username", username);
    const { config } = await getInitialAgentConfigAndInfo();
    await setLanguageBackend(config.language);
    const { properties } = await customGetUserProperties(config);

    //console.log(extension)
    //console.log(agent_data)
    //console.log(langResp)

    this.props.changeLang(properties.language);

    //----------------------------------------------------
    // Validar audiosettings.
    var self = this;
    const { setAudioSettings, set_showInvalidAudioSettingsMessage } = self.props;
    let { showInvalidAudioSettingsMessage } = self.props;

    navigator.mediaDevices
      .getUserMedia({ audio: true, video: false })
      .then(function () {

        navigator.mediaDevices.enumerateDevices()
          .then((devices) => {
            // console.log(devices);

            let audio_devices_allowed = devices.filter(
              (device) =>
                device.kind === "audiooutput" &&
                device.deviceId !== "default" &&
                device.deviceId !== "communications"
            )
            let audioOutputSelection = properties.audioSettings;

            // console.log('audio_devices_allowed ', audio_devices_allowed);
            // console.log('audioOutputSelection ', audioOutputSelection);
            // console.log('validate devices');

            if (self.deviceIsAllowed(audioOutputSelection.output_ring_device, audio_devices_allowed) && 
                self.deviceIsAllowed(audioOutputSelection.output_voice_device, audio_devices_allowed))
            {
                // El setting de audio es correcto.
                // console.log('Audiosettings OK');   

                // console.log('properties.audioSettings', audioOutputSelection);
                setAudioSettings(audioOutputSelection);
            }
            else
            {
                // El setting de audio es invalido.
                // console.log('Audiosettings KO');

                // Fijar el audio a predeterminado.
                const audioSettings = {         
                    output_ring_device: '',
                    output_voice_device: ''
                }
                // console.log('properties.audioSettings', audioOutputSelection);
                // console.log('properties.audioSettings', audioSettings);
                setAudioSettings(audioSettings);

                // Indicar que hay que mostrar el mensaje del webphone de audio devices mal.
                // console.log('PRE self', showInvalidAudioSettingsMessage);
                set_showInvalidAudioSettingsMessage(true);
            }

          })
          .catch((err) => console.error("Error listing audio devices:", err));  

      });
                   
    // console.log('properties.audioSettings', properties.audioSettings);
    // this.props.setAudioSettings(properties.audioSettings);
    //----------------------------------------------------

    this.setState({ properties: properties });
    if (agent_status) {
      const {
        connection_token,
        hasListenCall,
        hasHangup,
        hasRecordingCall,
        license,
        clientId,
      } = await customGetConnectionToken(agent_id);
      const permissions = {
        hasListenCall,
        hasHangup,
        hasRecordingCall,
        license,
      };
      const client = clientId;
      if (hadToken) {
        this.setState({ isLoginAction: true });
      }
      if (permissions.license === 3 || permissions.license === 4) {
        this.setState({ connectiontoken: connection_token }, () => {
          localStorage.setItem("agent_id", agent_id);
          localStorage.setItem("extension", extension);
          localStorage.setItem("clientId", client);
          this.setState({ isReloaded: true });
          this.getAgentConfigAndInfo(connection_token);
          this.props.getCustomLogo();
          this.defineMomentLocale();
          removeItem("loginTime");
          if (localStorage.getItem("agent_id")) {
            this.props.getOmniUrl();
          }
          this.props.setAgentPermission(permissions);
          window.addEventListener("online", this.handleOnlineEvent);
          window.addEventListener("offline", this.handleOfflineEvent);
        });
      } else {
        let location = window.location.href;

        if (location.includes("//test.invoxcontact.io")) {
          toastErrorMsg(
            this.props.translations.licenseError[this.props.selectedLanguage],
            this,
            "commonErrToast"
          );
          setTimeout(() => {
            window.location =
              "https://test.invoxcontact.io/login/?redirect=https://test.invoxcontact.io/webphonego/";
          }, 3000);
        } else if (location.includes("//staging.invoxcontact.io")) {
          toastErrorMsg(
            this.props.translations.licenseError[this.props.selectedLanguage],
            this,
            "commonErrToast"
          );
          setTimeout(() => {
            window.location =
              "https://staging.invoxcontact.io/login/?redirect=https://staging.invoxcontact.io/webphonego/";
          }, 3000);
        } else if (location.includes("//go.invoxcontact.io")) {
          toastErrorMsg(
            this.props.translations.licenseError[this.props.selectedLanguage],
            this,
            "commonErrToast"
          );
          setTimeout(() => {
            window.location =
              "https://go.invoxcontact.io/login/?redirect=https://go.invoxcontact.io/webphonego/";
          }, 3000);
        } else if (location.includes("//gtest.invoxcontact.io")) {
          toastErrorMsg(
            this.props.translations.licenseError[this.props.selectedLanguage],
            this,
            "commonErrToast"
          );
          setTimeout(() => {
            window.location =
              "https://gtest.invoxcontact.io/login/?redirect=https://gtest.invoxcontact.io/webphonego/";
          }, 3000);
        } else if (location.includes("//ggo.invoxcontact.io")) {
          toastErrorMsg(
            this.props.translations.licenseError[this.props.selectedLanguage],
            this,
            "commonErrToast"
          );
          setTimeout(() => {
            window.location =
              "https://ggo.invoxcontact.io/login/?redirect=https://ggo.invoxcontact.io/webphonego/";
          }, 3000);
        } else if (location.includes("//gstaging.invoxcontact.io")) {
          toastErrorMsg(
            this.props.translations.licenseError[this.props.selectedLanguage],
            this,
            "commonErrToast"
          );
          setTimeout(() => {
            window.location =
              "https://gstaging.invoxcontact.io/login/?redirect=https://gstaging.invoxcontact.io/webphonego/";
          }, 3000);
        } else {
          toastErrorMsg(
            this.props.translations.licenseError[this.props.selectedLanguage],
            this,
            "commonErrToast"
          );
          setTimeout(() => {
            window.location =
              "http://localhost:3002/login/?redirect=http://localhost:3001/webphonego";
          }, 3000);
        }
      }
    }
    this.checkAndRedirect();
  };
  
  
  componentWillMount() {
    // localStorage.setItem("username", "manolito33");
    // localStorage.setItem("username", "5299.422");
    //localStorage.setItem("username", "jclonicco");

    return checkLogin(this.postLogin);
  }


  // AKIII: Revisar la redireccion a version, en caso de webagent.
  checkAndRedirect() {
    const currentURL = window.location.href;
    const ioIndex = currentURL.indexOf(".io/");
    const webIndex = currentURL.indexOf("web");

    const goVersion = localStorage.getItem("goVersionWA") || localStorage.getItem("invoxVersion");

    if (!goVersion) return;

    if (goVersion !== "go") {
        const currentGoVersionIndex = currentURL.indexOf(goVersion);

        if (currentGoVersionIndex !== -1) {
            // If the URL already contains the correct goVersion, do nothing
            //console.log("do nothing version is correct");
            return;
        }
    }

    if (ioIndex !== -1 && webIndex !== -1 && webIndex > ioIndex) {
        // Extract the substring between ".io/" and "web"
        const substringToRemove = currentURL.substring(ioIndex + 4, webIndex);
        //console.log("substring to remove: " + substringToRemove);

        const substringIndex = currentURL.indexOf(substringToRemove, ioIndex + 4);
        if (substringIndex !== -1 && substringIndex === ioIndex + 4) {
            let newUrl = currentURL.slice(0, ioIndex + 4) + currentURL.slice(substringIndex + substringToRemove.length);

            if (goVersion !== "go") {
                newUrl = currentURL.slice(0, ioIndex + 4) + goVersion + "/" + newUrl.slice(ioIndex + 4);
            }

           // console.log("new URL: " + newUrl);
            window.location.replace(newUrl);
        }
    }
  }


  componentDidUpdate() {
    const {
      agentConfig,
      get_theme,
      set_theme,
      set_themecode,
      translations,
      selectedLanguage,
    } = this.props;

    if (
      agentConfig &&
      agentConfig.preference &&
      agentConfig.preference.themetype
    ) {
      const theme = agentConfig.preference.themetype;

      if (theme === "default") {
        set_theme("");
        get_theme(translations.light[selectedLanguage]);
        set_themecode(theme);
      } else if (theme === "darkblue") {
        set_theme("-dark");
        get_theme(translations.darkblue[selectedLanguage]);
        set_themecode(theme);
      } else if (theme === "dark") {
        set_theme("-black");
        get_theme(translations.dark[selectedLanguage]);
        set_themecode(theme);
      } else if (theme === "highContrast") {
        set_theme("-highContrast");
        get_theme(translations.highContrast[selectedLanguage]);
        set_themecode(theme);
      }
    }
  }
  //NOTE - DEPRECATED
  // loadCertificateIframe = () => {
  //   if (!document.getElementById('invox-cert')) {
  //     const iframe = document.createElement('iframe');
  //     iframe.src = "https://ws.invoxcontact.com:443";
  //     iframe.id = "invox-cert";
  //     document.body.appendChild(iframe);
  //   }
  // }

  handleOnlineEvent = () => {
    this.setState({ showOfflineAlert: false });
    // if (localStorage.getItem("agent_id")) {
    //   this.getAgentConfigAndInfo(this.state.connectiontoken);
    // }
  };

  handleOfflineEvent = () => {
    this.setState({ showOfflineAlert: true });
  };

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.agentConfig.panels_display) {
      if (
        nextProps.agentConfig.panels_display.web_phone === "required_signin" &&
        !this.state.isAgentConfigUpdated &&
        this.state.isReloaded
      ) {
        nextProps.agentConfig.panels_display["web_phone"] = true;
        const payload = {
          panels_display: nextProps.agentConfig.panels_display,
          panels_order: nextProps.agentConfig.panels_order,
        };
        this.props
          .setAgentConfigData(
            payload,
            this.props.agentInfo.has_chat_permissions,
            false,
            this.props.themecode
          )
          .then(
            (res) => {
              // if (res.data.result) {
              //   console.log("Success");
              // } else {
              //   console.log("Failed");
              // }
            },
            () => {
              logData("Test");
            }
          );
      }

      // nextProps.agentConfig.panels_display.web_phone ? this.loadCertificateIframe() : ''

      this.setState({ isAgentConfigUpdated: true });
      let isValid = true;
      const panels_display = this.isObject(nextProps.agentConfig.panels_display)
        ? nextProps.agentConfig.panels_display
        : {};
      if (Object.keys(panels_display).length > 0) {
        Object.keys(panels_display).forEach((key) => {
          if (!this.state.components[key] && key !== "web_phone") {
            isValid = false;
          }
        });
      } else {
        isValid = false;
      }
      if (isValid) {
        let panels_order = nextProps.agentConfig.panels_order;
        panels_order = Object.keys(panels_order).sort(function (a, b) {
          return panels_order[a] - panels_order[b];
        });
        this.setState({
          panels_order,
          panels_display: nextProps.agentConfig.panels_display,
          ignorePanels: ["chat"],
        });
      } else {
        this.renderPanels();
      }
    } else {
      this.renderPanels();
    }

    if (
      JSON.stringify(nextProps.omniData) !== JSON.stringify(this.props.omniData)
    ) {
      this.getOmniUrl();
    }

    if (nextProps.agentInfo !== this.props.agentInfo) {
      if (
        nextProps.agentInfo.agent_id &&
        this.props.agentInfo.agent_id != nextProps.agentInfo.agent_id
      ) {
        const currentTime = moment().unix();
        let loginTime = getItem("loginTime");
        if (loginTime) {
          loginTime = moment(parseInt(loginTime) * 1000);
          const hourDifference = moment().diff(loginTime, "hours", true);
          if (hourDifference > 18) {
            this.logout();
          }
        } else {
          setItem("loginTime", currentTime);
        }
        this.setState(
          {
            isAgentListPage:
              getParameterByName("isAgentPage") == "true" &&
              nextProps.agentInfo.supervisor,
          },
          () => {
            this.props.getQueuedCalls();
            this.activateAgentNavBarStyle();
            if (!this.state.isAgentListPage) {
              const newURL = window.location.href.split("?")[0];
              window.history.replaceState("object", document.title, newURL);
              this.props.getIncomingCalls();
              this.props.getOutgoingCalls();
              this.props.getAuotoDialerCalls();
              this.props.getAvailabilityList();
            }
            // else{
            //   this.props.getServicesListByClient();
            // }
          }
        );
        this.props.setTabLock();
        this.props.getServicesListByAgent();
        this.props.getAllAgents();
        // this.props.getAgents();
        // this.props.getSupervisors();
        if (this.state.isLoginAction) {
          this.props.setOnline().then(
            () => {
              this.props.changeDefaultAvailability(
                nextProps.agentInfo.default_availability_state
              );
            },
            (err) => {
              logData(err);
              toastErrorMsg(
                this.props.translations.commonErrorText[
                  this.props.selectedLanguage
                ],
                this,
                "commonErrToast"
              );
            }
          );
        }
      }
    }
    if (nextProps.reopenTab.data.id) {
      //const win = window.open('', '_blank');
      if (nextProps.reopenTab.data.id !== this.props.reopenTab.data.id) {
        this.getCallUrl("addCallEvent", nextProps.reopenTab);
      } else if (
        nextProps.reopenTab.data.timestamp !=
        this.props.reopenTab.data.timestamp
      ) {
        this.getCallUrl("addCallEvent", nextProps.reopenTab);
      }
    }
    if (nextProps.doCall) {
      const data = {
        asProp: true,
        ...nextProps.phonePayload,
      };
      this.makeCall(data);
    }
  };

  defineMomentLocale = () => {
    availableLanguages.forEach((item) => {
      this.defineLocaleForLanguage(item.code);
    });
  };

  defineLocaleForLanguage = (lang) => {
    const { translations } = this.props;

    moment.updateLocale(lang, {
      parentLocale: "en",
      months: [
        translations.january[lang],
        translations.february[lang],
        translations.march[lang],
        translations.april[lang],
        translations.may[lang],
        translations.june[lang],
        translations.july[lang],
        translations.august[lang],
        translations.september[lang],
        translations.october[lang],
        translations.november[lang],
        translations.december[lang],
      ],
      monthsShort: [
        translations.januaryShort[lang],
        translations.februaryShort[lang],
        translations.marchShort[lang],
        translations.aprilShort[lang],
        translations.mayShort[lang],
        translations.juneShort[lang],
        translations.julyShort[lang],
        translations.augustShort[lang],
        translations.septemberShort[lang],
        translations.octoberShort[lang],
        translations.novemberShort[lang],
        translations.decemberShort[lang],
      ],
      weekdays: [
        translations.sunday[lang],
        translations.monday[lang],
        translations.tuesday[lang],
        translations.wednesday[lang],
        translations.thursday[lang],
        translations.friday[lang],
        translations.saturday[lang],
      ],
      weekdaysShort: [
        translations.sundayShort[lang],
        translations.mondayShort[lang],
        translations.tuesdayShort[lang],
        translations.wednesdayShort[lang],
        translations.thursdayShort[lang],
        translations.fridayShort[lang],
        translations.saturdayShort[lang],
      ],
      weekdaysMin: [
        translations.sundayShort[lang],
        translations.mondayShort[lang],
        translations.tuesdayShort[lang],
        translations.wednesdayShort[lang],
        translations.thursdayShort[lang],
        translations.fridayShort[lang],
        translations.saturdayShort[lang],
      ],
      week: {
        dow: 1,
      },
    });
  };

  isObject = (item) => {
    return typeof item === "object" && !Array.isArray(item) && item !== null;
  };
  // handles error when login fails
  handleAuthError = () => {
    toastErrorMsg(
      this.props.translations.commonErrorText[this.props.selectedLanguage],
      this,
      "commonErrToast2"
    );
    handleLogoutRedirect();
    // window.location = 'https://login.invoxcontact.com/';
  };

  // gets agents info and config via paralell api call
  getAgentConfigAndInfo = (connection_token) => {
    this.props.getAgentConfigAndInfo(this.state.properties).then(
      () => {
        // const payload = {
        //   text: '<!channel> Testing notification'
        // };
        // this.props.slackNotification(payload);
      },
      (err) => {
        logData(err);
      }
    );

    if (connection_token) {
      this.connectToListener(connection_token);
    } else {
      toastErrorMsg(
        this.props.translations.listenerError[this.props.selectedLanguage],
        this,
        "listenerErrToast"
      );
    }
  };

  // connects to call event listener
  connectToListener = (token) => {
    window.addEventListener("blur", () => {
      let actEl;
      try {
        actEl = document.activeElement;
      } catch (ex) {
        actEl = document.body;
      }

      if (actEl && actEl.tagName == "IFRAME") {
        this.props.closeMenuPopup();
      }
    });

    window.didConnect = () => {
      logData("Connected");
      // this.props.getQueuedCalls();
      // this.activateAgentNavBarStyle()
      // this.props.getIncomingCalls();
      // this.props.getOutgoingCalls();
      // this.props.getAuotoDialerCalls();
      // this.props.getAvailabilityList();
      // this.props.setTabLock();
      // this.props.getServicesListByAgent();
      // this.props.getAllAgents();
      this.setState({
        listenerConnected: true,
      });
    };
    window.connectionError = () => {
      logData("disconnected");
      toastErrorMsg(
        this.props.translations.listenerError[this.props.selectedLanguage],
        this,
        "listenerErrToast2"
      );
    };
    window.incomingEarly = (data) => {
      logData(JSON.parse(JSON.stringify(data)));
      if (data) {
        let service = this.props.serviceList.find(
          (item) => item.id == data.data.service_id
        );
        let service_name =
          data.data && data.data.service_name
            ? data.data.service_name
            : service
            ? service.name
            : "";
        if (service_name) {
          data.data.service_name = service_name;
        }
        if (data.data.extension == this.props.agentInfo.extension) {
          // let duplicate = this.props.incomingCallsList.find(item => item.data.id === data.data.id);
          let duplicate = this.incomingCallist.find(
            (item) => item.data.id === data.data.id
          );
          if (!duplicate) {
            duplicate = this.props.activeTabs.find(
              (item) => item.data.id === data.data.id
            );
          }

          //first remove duplicated call and adds it again (because sometimes when the call event comes for the first time service id is missing)
          if (duplicate) {
            this.incomingCallist = this.incomingCallist.filter(
              (item) => item.data.id !== data.data.id
            );
            this.props.incomingMissed(data, this.props.agentInfo.timezone);
            this.props.removeIncomingCall(data);
            this.props.removeNotification(data.data.id);
            this.props.notificationOpened();
            this.setState({
              onGoingCallData: {},
            });
          }

          this.incomingCallist.push(data);
          this.props.callStarted(data);
          this.getCallUrl("addCallEvent", data);
          this.props.addIncomingCall(data);
          this.props.showWebphone(true);
          this.setState({
            onGoingCallData: { ...data.data, callStartTime: moment().unix() },
          });
        }
        this.props.queuedCalls.forEach((call) => {
          if (call.linkedid == data.data.id) {
            data.data.service_name = call.service_name;
          }
        });

        data.data.unique_call_id =
          data.data.id + "_" + data.data.from + "_" + data.data.to;
        let existingCall = this.checkExistingCall(data.data.extension);
        data.data.startTime = existingCall
          ? existingCall.startTime
          : moment().unix();
        this.props.agentOnCall(data);
        this.updateCallData(data.data);
        const agentsAndSupervisors = [
          ...this.props.agents,
          ...this.props.supervisors,
        ];
        const queueData = {};
        agentsAndSupervisors.forEach((item) => {
          if (data.data.extension == item.extension) {
            queueData.linkedid = data.data.id;
            queueData.agent_name = item.name;
          }
        });
        this.props.modifyQueueCalls(queueData);
      } else {
        logData("ERROR OCCURED IN incomingEarly", data);
        const payload = {
          text: "<!channel> ERROR OCCURED IN incomingEarly",
        };
        this.props.slackNotification(payload);
      }
    };
    window.incomingAnswered = (data) => {
      if (data.data.extension == this.props.agentInfo.extension) {
        this.props.callAnswered(data);
        //let duplicate = this.props.incomingCallsList.find(item => item.data.id === data.data.id);
        let duplicate = this.incomingCallist.find(
          (item) => item.data.id === data.data.id
        );
        if (!duplicate) {
          duplicate = this.props.activeTabs.find(
            (item) => item.data.id === data.data.id
          );
        }

        if (!duplicate) {
          this.incomingCallist.push(data);
          this.getCallUrl("addCallEvent", data);
          this.props.addIncomingCall(data);
        }
      }
      const service = this.props.serviceList.find(
        (item) => item.id == data.data.service_id
      );
      data.data.service_name =
        data.data && data.data.service_name
          ? data.data.service_name
          : service
          ? service.name
          : "";
      data.data.unique_call_id =
        data.data.id + "_" + data.data.from + "_" + data.data.to;
      let existingCall = this.checkExistingCall(data.data.extension);
      data.data.startTime = existingCall
        ? existingCall.startTime
        : moment().unix();
      this.props.agentOnCallAnswered(data);
      this.updateCallData(data.data);

      let eventData = this.props.callUrlData.find(
        (item) => item.data.id === data.data.id
      );
      if (eventData && eventData.data.url_on_accept_call) {
        this.callUrlOnAccept(eventData.data.url_on_accept_call);
      }

      logData("incomingAnswered", data);
    };
    window.incomingTerminated = (data) => {
      if (data.data.extension == this.props.agentInfo.extension) {
        this.incomingCallist = this.incomingCallist.filter(
          (item) => item.data.id !== data.data.id
        );
        this.props.incomingTerminated(data);
        this.setState({
          callTerminate: data.data.id,
          callTerminateTime: moment().unix(),
        });
        this.props.removeIncomingCall(data);
      }
      data.data.unique_call_id =
        data.data.id + "_" + data.data.from + "_" + data.data.to;
      this.updateCallData(data.data);
      let prevCallData = this.checkExistingCall(data.data.extension);
      if (prevCallData) {
        this.props.agentOnCall({ data: prevCallData });
      } else {
        this.props.agentCallTerminated(
          data,
          this.props.agentInfo.extra_data.talk_is_state || "0"
        );
      }
      logData("incomingTerminated", data);
    };
    window.incomingMissed = (data) => {
      logData(JSON.parse(JSON.stringify(data)));
      if (data) {
        const service = this.props.serviceList.find(
          (item) => item.id == data.data.service_id
        );
        if (service) {
          data.data.service_name = service.name;
        }
      }
      if (data.data.extension == this.props.agentInfo.extension) {
        this.props.incomingMissed(data, this.props.agentInfo.timezone);
        this.setState({
          callTerminate: data.data.id,
          callTerminateTime: moment().unix(),
        });

        // FE-74-Notification missed call
        if (data.data.queue_id) {
          this.props.removeNotification(data.data.id);
          this.props.notificationOpened();
        }
      }
      this.props.agentCallTerminated(data);
    };
    window.outgoingEarly = (data) => {
      // logData(JSON.parse(JSON.stringify(data)));
      if (data) {
        const service = this.props.serviceList.find(
          (item) => item.id == data.data.service_id
        );
        const service_name =
          data.data && data.data.service_name
            ? data.data.service_name
            : service
            ? service.name
            : "";
        if (service_name) {
          data.data.service_name = service_name;
        }
        if (data.data.extension === this.props.agentInfo.extension) {
          //const duplicate = this.props.currentOutgoingCalls.find(item => item.data.id === data.data.id);
          let duplicate = this.outgoingCallist.find(
            (item) => item.data.id === data.data.id
          );
          if (!duplicate) {
            duplicate = this.props.activeTabs.find(
              (item) => item.data.id === data.data.id
            );
          }

          if (!duplicate) {
            this.outgoingCallist.push(data);
            this.props.callStarted(data);
            this.getCallUrl("addCallEvent", data);
            this.props.addOutgoingCall(data);
            if (data.data.autodialer_id) {
              this.setState({
                onGoingCallData: {
                  ...data.data,
                  callStartTime: moment().unix(),
                },
              });
            }
          }
        }
        data.data.unique_call_id =
          data.data.id + "_" + data.data.from + "_" + data.data.to;
        let existingCall = this.checkExistingCall(data.data.extension);
        data.data.startTime = existingCall
          ? existingCall.startTime
          : moment().unix();

        this.props.agentOnCall(data);
        this.updateCallData(data.data);
      } else {
        logData("ERROR OCCURED IN outgoingEarly", data);
        const payload = {
          text: "<!channel> ERROR OCCURED IN outgoingEarly",
        };
        this.props.slackNotification(payload);
      }
    };
    window.outgoingAnswered = (data) => {
      if (data.data.extension == this.props.agentInfo.extension) {
        this.props.callAnswered(data);
        // const duplicate = this.props.currentOutgoingCalls.find(item => item.data.id === data.data.id);
        let duplicate = this.outgoingCallist.find(
          (item) => item.data.id === data.data.id
        );
        if (!duplicate) {
          duplicate = this.props.activeTabs.find(
            (item) => item.data.id === data.data.id
          );
        }
        if (!duplicate) {
          this.outgoingCallist.push(data);
          this.getCallUrl("addCallEvent", data);
          this.props.addOutgoingCall(data);
        }
      }

      this.props.updateOutgoingCall(data);
      data.data.unique_call_id =
        data.data.id + "_" + data.data.from + "_" + data.data.to;
      const service = this.props.serviceList.find(
        (item) => item.id == data.data.service_id
      );
      data.data.service_name =
        data.data && data.data.service_name
          ? data.data.service_name
          : service
          ? service.name
          : "";
      let existingCall = this.checkExistingCall(data.data.extension);
      data.data.startTime = existingCall
        ? existingCall.startTime
        : moment().unix();
      this.props.agentOnCallAnswered(data);
      this.updateCallData(data.data);

      const eventData = this.props.callUrlData.find(
        (item) => item.data.id === data.data.id
      );
      if (eventData && eventData.data && eventData.data.url_on_accept_call) {
        this.callUrlOnAccept(eventData.data.url_on_accept_call);
      }

      logData("outgoingAnswered", data);
    };
    window.outgoingTerminated = (data) => {
      if (data.data.extension == this.props.agentInfo.extension) {
        this.outgoingCallist = this.outgoingCallist.filter(
          (item) => item.data.id !== data.data.id
        );
        this.props.outgoingTerminated(data);
        if (data.data.autodialer_id) {
          const currentOutgoing = this.props.currentOutgoingCalls.find(
            (item) => item.data.id === data.data.id
          );
          if (
            currentOutgoing &&
            currentOutgoing.data &&
            currentOutgoing.data.answered == 0
          ) {
            this.props.deleteCallEvent(currentOutgoing);
            this.props.setResetActiveTab(true);
          }
          this.setState({
            callTerminate: data.data.id,
            callTerminateTime: moment().unix(),
          });
        }
        this.props.removeOutgoingCall(data);
      }
      data.data.unique_call_id =
        data.data.id + "_" + data.data.from + "_" + data.data.to;
      this.updateCallData(data.data);
      let prevCallData = this.checkExistingCall(data.data.extension);
      if (prevCallData) {
        this.props.agentOnCall({ data: prevCallData });
      } else {
        this.props.agentCallTerminated(
          data,
          this.props.agentInfo.extra_data.talk_is_state || "0"
        );
      }
      logData("Outgoing terminate", data);
    };
    window.agnetStatusChanged = (data) => {
      logData(JSON.parse(JSON.stringify(data)));
      if (data) {
        if (this.props.agentInfo.agent_id == data.data.user_id) {
          this.props.setCallAvailability(data.data.user_status);
          if (!data.data.web_online) {
            setTimeout(() => {
              if (!localStorage.getItem("agent_id")) {
                handleLogoutRedirect();
              }
            }, 2000);
          }
        }
        const currentAgent = this.props.agents.find(
          (item) => item.id == data.data.user_id
        );
        if (data.data.services_status && currentAgent) {
          data.data.services_status.forEach((item, key) => {
            data.data.services_status[key].status_begin_timestamp =
              (currentAgent.availability_detail[key] &&
                currentAgent.availability_detail[key].status_begin_timestamp) ||
              "";
            if (
              data.data.services_status[key].status !==
              currentAgent.availability_detail[key].status
            ) {
              data.data.services_status[key].status_begin_timestamp =
                data.data.services_status[key].date;
            }
            if (item.motive_description.length > 0) {
              data.data.reason = item.motive_description;
            }
          });
        }
        this.props.updateAgentsCallAvailability(data);
      } else {
        logData("ERROR OCCURED IN agnetStatusChanged", data);
        const payload = {
          text: "<!channel> ERROR OCCURED IN agnetStatusChanged",
        };
        this.props.slackNotification(payload);
      }
    };
    window.serviceChange = (data) => {
      const payload = {
        service_id: data.data,
      };
      this.props.setDefaultService(payload);
      this.props.agentInfo.calling_service_name = data.name;
      this.props.getAgentInfo();
    };
    window.whiperSessionBegin = (data) => {

      // Mostrar el webphone en primer plano.
      this.props.showWebphone(true);

      // Mostrar una notificacion de Whisper, 
      // ante la imposibilidad de poner en primer plano el webagent con telefono.
      let notification = null;
      
      if (data.data == "Spy")
      {
          // Spy call ongoing
          notification = new Notification(
              this.props.translations.whisperNotificationTitle[this.props.selectedLanguage], 
              {
                  body: this.props.translations.whisperSpyNotification[this.props.selectedLanguage],
                  requireInteraction: true,
                  lang: this.props.selectedLanguage
              }
          );
      }
      else if (data.data == "Adviser")
      {
          // Advice call ongoing
          notification = new Notification(
              this.props.translations.whisperNotificationTitle[this.props.selectedLanguage], 
              {
                  body: this.props.translations.whisperAdviserNotification[this.props.selectedLanguage],
                  requireInteraction: true,
                  lang: this.props.selectedLanguage
              }
          );
      }

    };
    window.QueueCallerJoinEvent = (data) => {
      logData("QueueCallerJoin", data);
      const service = this.props.serviceList.find(
        (item) =>
          item.id.toString() == data.headers.service.serviceid.toString()
      );
      if (service) {
        this.props.queueCallJoin(data.headers);
      }
    };
    window.QueueCallerLeaveEvent = (data) => {
      logData("QueueCallerLeave", data);
      const service = this.props.serviceList.find(
        (item) =>
          item.id.toString() == data.headers.service.serviceid.toString()
      );
      if (service) {
        this.props.queueCallLeave(data.headers);
      }
    };
    window.QueueCallNoAnswer = (data) => {
      logData("QueueCallNoAnswer", data);
      const service = this.props.serviceList.find(
        (item) =>
          item.id.toString() == data.headers.service.serviceid.toString()
      );
      if (service) {
        this.props.queueCallNoAnswer(data.headers);
      }
    };
    window.actionEvent = (data) => {
      if (data.data.action === "close_tab") {
        let callEvent = this.props.activeTabs.find(
          (item) =>
            item.data.id === (data.data.params && data.data.params.callid)
        );
        if (callEvent) {
          // this.currentActiveTabs = this.props.activeTabs.filter(item => item.data.id === (data.data.params && data.data.params.callid))
          this.props.deleteCallEvents([callEvent]);
          if (this.props.activeTabs.length === 0) {
            this.props.setResetActiveTab(true);
          }
        }
      } else if (data.data.action === "refresh_panels") {
        this.refreshRightPanel();
      } else if (data.data.action === "external_message") {
        let notification = new Notification("Message", {
          body:
            (data.data.params && data.data.params.message) || "Nothing to show",
          requireInteraction: true,
        });
      }
      logData("action: ", data.data.action);
    };
    try {
      const listener = new window.Listener({
        token: token,
        listen: ["call.*", "status", "queue"],
        actions: {
          system: {
            on_connect: "didConnect",
            //"on_disconnect": "connectionError"
          },
          calls: {
            on_incoming_call_early: "incomingEarly",
            on_incoming_call_answered: "incomingAnswered",
            on_incoming_call_terminated: "incomingTerminated",
            on_incoming_call_missed: "incomingMissed",
            on_outgoing_call_early: "outgoingEarly",
            on_outgoing_call_answered: "outgoingAnswered",
            on_outgoing_call_terminated: "outgoingTerminated",
            availability_info_detail: "agnetStatusChanged",
            queuecallerjoin: "QueueCallerJoinEvent",
            queuecallerabandon: "QueueCallerLeaveEvent",
            queuecallerleave: "QueueCallerLeaveEvent",
            agentconnect: "QueueCallerLeaveEvent",
            agentringnoanswer: "QueueCallNoAnswer",
            action: "actionEvent",
            service_change: "serviceChange",
            whiper_session_begin: "whiperSessionBegin"
          },
        },
      });
      listener.connect();
    } catch (err) {
      logData("An error has ocurred");
      logData(err);
      toastErrorMsg(
        this.props.translations.listenerError[this.props.selectedLanguage],
        this,
        "listenerErrToast3"
      );
    }
  };

  refreshRightPanel = () => {
    this.props.getServicesListByAgent();
    this.props.getAllAgents();
    this.props.getIncomingCalls();
    this.props.getOutgoingCalls();
    this.props.getQueuedCalls();
    this.props.getAuotoDialerCalls();
  };

  callUrlOnAccept = (url) => {
    axios
      .get(url)
      .then((response) => {
        logData(response);
      })
      .catch((error) => {
        logData(error);
      });
  };

  removeCallIdFromList = (unique_call_id, extension) => {
    let callListCopy = [...this.props.agentsOnCallList];

    let index = callListCopy.findIndex(
      (callList) =>
        callList.callData.unique_call_id === unique_call_id &&
        callList.callData.extension === extension
    );
    if (index != -1) {
      callListCopy.splice(index, 1);
    }
    return callListCopy;
  };

  checkExistingCall = (extension) => {
    let index = this.props.agentsOnCallList.findIndex(
      (callList) =>
        callList.callData.extension === extension &&
        callList.callData.state !== "early"
    );
    if (index != -1) {
      return this.props.agentsOnCallList[index].callData;
    } else {
      return false;
    }
  };

  updateCallData = (callData) => {
    let updatedList;
    if (callData.state === "early") {
      updatedList = [...this.props.agentsOnCallList];
      let index = updatedList.findIndex(
        (callList) =>
          callList.callData.unique_call_id === callData.unique_call_id &&
          callList.callData.extension === callData.extension
      );
      if (index != -1) {
        let answeredCallData = updatedList[index];
        updatedList.splice(index, 1);
        callData.startTime =
          answeredCallData.callData.startTime || moment().unix();
      }
      updatedList.push({ callData: callData });
    } else if (callData.state === "answered") {
      updatedList = [...this.props.agentsOnCallList];
      let index = updatedList.findIndex(
        (callList) =>
          callList.callData.unique_call_id === callData.unique_call_id &&
          callList.callData.extension === callData.extension
      );
      if (index != -1) {
        let answeredCallData = updatedList[index];
        updatedList.splice(index, 1);
        callData.service_name = answeredCallData.callData.service_name;
        callData.startTime = answeredCallData.callData.startTime;
        callData.didAnswer = true;
        callData.busy = true;
        updatedList.push({ callData: callData });
      } else {
        const service = this.props.serviceList.find(
          (item) => item.id == callData.service_id
        );
        callData.service_name = callData.service_name
          ? callData.service_name
          : service
          ? service.name
          : "";
        callData.didAnswer = true;
        callData.busy = true;
        updatedList.push({ callData: callData });
      }
    } else if (callData.state === "terminated") {
      updatedList = this.removeCallIdFromList(
        callData.unique_call_id,
        callData.extension
      );
    }
    logData("agentsOnCallList", updatedList);
    this.props.setAgentsOnCallList(updatedList || []);
  };

  checkIfMaxTabs = (call_id) => {
    let bool = true;
    const uniqueCallsLength = getUniqueCalls(this.props.activeTabs);
    const duplicate = this.props.activeTabs.find(
      (item) => item.data.id === call_id
    );
    if (
      this.props.agentInfo.max_call_tabs != 0 &&
      duplicate &&
      uniqueCallsLength >= this.props.agentInfo.max_call_tabs
    ) {
      bool = false;
    } else if (
      this.props.agentInfo.max_call_tabs != 0 &&
      uniqueCallsLength >= this.props.agentInfo.max_call_tabs
    ) {
      toastErrorMsg(
        this.props.translations.maxTabError[this.props.selectedLanguage],
        this,
        "maxTabsToast"
      );
      bool = false;
    }
    return bool;
  };

  // gets url and service name for call event
  getCallUrl = (action_name, data) => {
    logData(data);
    const checkTabs = this.checkIfMaxTabs(data.data.id);
    if (checkTabs) {
      let call_id = data.data.id;
      const type = data.data.type === "outgoing" ? "out" : "in";
      // const type = data.data.to === this.props.agentInfo.extension ? 'in' : 'out';
      setTimeout(() => {
        this.props
          .getCallUrl(
            call_id,
            data.data.service_id,
            data.data.to,
            data.data.from,
            data.data.autodialer_id,
            type
          )
          .then(
            (res) => {
              if (res.data.result) {
                data.data.url =
                  res.data.response.items[0].data.url.length > 0
                    ? res.data.response.items[0].data.url
                    : null;
                data.data.service_name =
                  res.data.response.items[0].data.service_name.length > 0
                    ? res.data.response.items[0].data.service_name
                    : null;
                data.data.open_popup =
                  res.data.response.items[0].data.open_popup;
                data.data.mandatory_end_of_business =
                  res.data.response.items[0].data.mandatory_end_of_business;
                data.data.url_on_accept_call =
                  res.data.response.items[0].data.url_on_accept_call;
                data.data.service_id = res.data.response.items[0].data
                  .service_id
                  ? res.data.response.items[0].data.service_id
                  : data.data.service_id;
                this.props["setCallUrlData"](data);
                if (res.data.response.items[0].data.url.length > 0) {
                  if (res.data.response.items[0].data.open_popup) {
                    popupLink = filterUrl(res.data.response.items[0].data.url);
                    const popupWindow = window.open(popupLink, "_blank");
                    if (
                      !popupWindow ||
                      popupWindow.closed ||
                      typeof popupWindow.closed == "undefined"
                    ) {
                      //POPUP BLOCKED
                    }
                  } else {
                    this.currentActiveTabs.push(data);
                    this.props[action_name](data);
                    setTimeout(() => {
                      this.props.setTabLock();
                    }, 100);
                  }
                } else {
                  if (
                    res.data.response.items[0].data.open_void == "1" &&
                    !res.data.response.items[0].data.open_popup
                  ) {
                    this.currentActiveTabs.push(data);
                    this.props[action_name](data);
                    setTimeout(() => {
                      this.props.setTabLock();
                    }, 100);
                  }
                }
              }
            },
            () => {
              toastErrorMsg("Error while getting url", this, "urlErrToast");
            }
          );
      }, 1000);
    }
  };

  // updates state with default sorting and display for right side panel
  renderPanels = () => {
    const panels_order = [
      "telephony",
      "calls_in_queue",
      "incoming_calls",
      "outgoing_calls",
      "chat",
      "agent",
      "autodialer",
    ];
    const panels_display = {
      telephony: true,
      calls_in_queue: true,
      incoming_calls: true,
      outgoing_calls: true,
      chat: false,
      agent: true,
      autodialer: true,
    };
    this.setState({ panels_order, panels_display });
  };

  // renders right side panels with order they are set in config
  panelOrder = () => {
    return this.state.panels_order.map((item) => {
      if (
        item !== "web_phone" &&
        this.state.panels_display[item.toString()] &&
        this.state.ignorePanels.indexOf(item.toString()) == -1
      ) {
        const PanelName = this.state.components[item.toString()];
        return (
          <PanelName key={item.toString()} />
        );
      } else {
        return null;
      }
    });
  };

  close = (key) => {
    this.setState({ [key]: false });
  };

  open = (key) => {
    this.setState({ [key]: true });
  };
  // toggles full screen for tabs section
  fullScreenToggle = () => {
    this.setState(
      {
        fullScreen: !this.state.fullScreen,
      },
      () => {
        this.props.fullScreenChange(this.state.fullScreen);
      }
    );
  };

  handleAgentSearch = (agentSearch) => {
    this.setState({
      agentSearch,
    });
  };

  switchAgentMonitorView = () => {
    let activeMonitorView = "";
    if (this.state.activeMonitorView == "AgentsMonitorWithService") {
      activeMonitorView = "AgentsDetails";
    } else {
      activeMonitorView = "AgentsMonitorWithService";
    }
    this.setState({
      activeMonitorView,
    });
  };

  // makes call
  makeCall = (data) => {
    // console.log(data)
    const phoneNumber = data.asProp
      ? filterPhoneNumber(data.phoneNumber)
      : filterPhoneNumber(this.state.phone);
    if (phoneNumber.length === 0) {
      toastErrorMsg(
        this.props.translations.onlyNumbers[this.props.selectedLanguage],
        this,
        "onlyNumToast"
      );
      return;
    }
    const payload = {
      extension: this.props.agentInfo.extension,
      phone: phoneNumber,
    };
    this.props.resetCall();
    if (this.props.agentInfo.ask_for_call_service == "0" || data.internalCall) {
      this.props.makeOutgoingCall(payload, data.internalCall).then(
        (res) => {
          if (!res.data.result) {
            toastErrorMsg(
              this.props.translations.callFailed[this.props.selectedLanguage],
              this,
              "callFailedToast2"
            );
          }
        },
        (err) => {
          const message = err === "maxTabError" ? "maxTabError" : "callFailed";
          toastErrorMsg(
            this.props.translations[message][this.props.selectedLanguage],
            this,
            "callFailedToast"
          );
        }
      );
    } else {
      if (
        this.props.agentInfo.max_call_tabs != 0 &&
        getUniqueCalls(this.props.activeTabs) >=
          this.props.agentInfo.max_call_tabs
      ) {
        toastErrorMsg(
          this.props.translations.maxTabError[this.props.selectedLanguage],
          this,
          "maxTabsToast2"
        );
      } else {
        payload.service_id = this.props.agentInfo.calling_service_id;
        this.setState({
          payload,
          showAskForServiceModal: true,
        });
      }
    }
  };

  // logs out user
  logout = () => {
    // console.log('logout app.js')
    this.props.doLogout().then(
      (res) => {
        if (res.data.result) {
          let data = {
            Logout: "isLogout",
          };
          var webphoneElement = document.getElementById("phone-iframe")
            ? document.getElementById("phone-iframe").contentWindow
            : null;
          if (webphoneElement) {
            const currentDomain = getWebPhoneDomain();
            //console.log('current domain',currentDomain)
            webphoneElement.postMessage(data, currentDomain);
          }

          // setTimeout(function() {
          handleLogoutRedirect();
          // }, 1);
        } else {
          toastErrorMsg(
            this.props.translations.commonErrorText[
              this.props.selectedLanguage
            ],
            this,
            "commonErrToast3"
          );
        }
      },
      (err) => {
        toastErrorMsg(
          this.props.translations.commonErrorText[this.props.selectedLanguage],
          this,
          "commonErrToast4"
        );
      }
    );
  };

  handleLogoutRedirectInApp = () => {
    // removeItem('agent_id');
    // removeItem('license');
    // removeItem('connection_token');
    // removeItem('loginTime');
    // let loginUrl;
    // if (this.state.websiteUrl.includes('agenttest.invoxcontact.com')) {
    //   loginUrl = 'https://login.invoxcontact.com?environ=devel';
    // } else if (this.state.websiteUrl.includes('agentpre.invoxcontact.com')) {
    //   loginUrl = 'https://login.invoxcontact.com?environ=preproduction';
    // } else {
    //   loginUrl = 'https://login.invoxcontact.com';
    // }
    // window.location = loginUrl;
  };

  toggleContent = () => {
    this.setState({
      selectedContent: this.state.selectedContent === PANELS ? BROWSER : PANELS,
    });
  };

  activateAgentNavBarStyle = () => {
    const element = document.getElementById("AppNavBar");
    const containerFluidDiv = element.getElementsByClassName("container-fluid");

    if (containerFluidDiv.length) {
      if (this.state.isAgentListPage) {
        containerFluidDiv[0].classList.add("flex-style");
        element.classList.add("example");
      } else {
        containerFluidDiv[0].classList.remove("flex-style");
        element.classList.remove("example");
      }
    }
  };

  render = () => {
    const { onGoingCallData, callTerminate, callTerminateTime } = this.state;

    const {
      translations,
      selectedLanguage,
      callAvailable,
      agentInfo,
      onGoingCalls,
      logo,
      agentConfig,
    } = this.props;

    return (
      <div className={this.state.showOfflineAlert ? " offline-container" : ""}>
        
        <Alert
          bsStyle="warning"
          className={
            "internetAlert" +
            (this.state.showOfflineAlert ? " internetAlert-show" : "")
          }
        >
          <div className="internetAlert-inner">
            <div className="internetAlert-icon">
              <i className="icon-unlink" style={{ fontSize: "21px" }} />
            </div>
            <div className="internetAlert-text">
              <span>
                &nbsp;&nbsp;{translations.offlineAlert[selectedLanguage]}
              </span>
            </div>
          </div>
        </Alert>
        <MfaModal show={this.state.showModal} step="step1" onClose={() => this.setState({ showModal: false})}/>
        <article
          className={`page-wrapper${this.props.theme} app-page _branded`}
          id="user-page"
          style={{ display: agentInfo.agent_id ? "block" : "none" }}
        >
        
          <Navbar
            className={`navbar-inverse${this.props.theme}`}
            id="AppNavBar"
            inverse
            fixedTop
            fluid
            collapseOnSelect
          >
            <Navbar.Header>
              <Navbar.Brand>
                <a
                  href="http://www.numintec.com/"
                  target="_blank"
                  className="navbar-brand"
                  style={{ padding: "2px 2px", display: "inline-flex" }}
                >
                  {
                    <img
                      alt="Numintec"
                      style={{
                        maxHeight: "46px",
                        margin: "auto 0",
                        height: logo ? "auto" : "21px",
                        paddingLeft: logo ? "" : "10px",
                      }}
                      src={logo ? logo : numintecLogo}
                      className="logo-not-branded"
                    />
                  }
                </a>
              </Navbar.Brand>
              {!this.state.isAgentListPage && <NotificationMenu />}
              {!this.state.isAgentListPage && <Navbar.Toggle />}
            </Navbar.Header>
            <Navbar.Collapse>
              {!this.state.isAgentListPage && (
                <Nav pullRight>
                  <UserMenu logout={this.logout} />
                  <li className="user-icon">
                    <a
                      href={undefined}
                      data-toggle="modal"
                      onClick={() => this.open("showAvailabilityModal")}
                      data-target="#userModal"
                    >
                      <span
                        className={`user-status user-${
                          callAvailable ? "available" : "unavailable"
                        }`}
                        style={{
                          borderRadius: "10%",
                        }}
                        title={
                          translations[
                            callAvailable ? "callAvailable" : "callUnavailable"
                          ][selectedLanguage]
                        }
                      >
                        <span className="icon icon-phone" />
                      </span>
                    </a>
                  </li>
                  <li
                    className="user-icon"
                    style={{ paddingTop: 15, color: "white" }}
                  >
                    {agentConfig.panels_display &&
                      agentConfig.panels_display.web_phone === true && (
                        <PhoneFooter />
                      )}
                  </li>

                  <AvailabilityModal
                    showAvailabilityModal={this.state.showAvailabilityModal}
                    handleClose={() => this.close("showAvailabilityModal")}
                  />
                  <NotificationMenu />
                  <li className="exit-button" onClick={this.logout}>
                    <a href={undefined}>
                      <span className="icon icon-power-plug padding_right_5" />
                      <strong>{translations.logout[selectedLanguage]}</strong>
                    </a>
                  </li>
                </Nav>
              )}
              {!this.state.isAgentListPage && <HeaderSearch />}
            </Navbar.Collapse>
            {this.state.isAgentListPage && (
              <AgentHeaderSearch handleAgentSearch={this.handleAgentSearch} />
            )}
            {this.state.isAgentListPage && (
              <Nav pullRight>
                <li onClick={this.switchAgentMonitorView}>
                  <a href={undefined}>
                    <strong>
                      {translations.switchScreen[selectedLanguage]}
                    </strong>
                  </a>
                </li>
              </Nav>
            )}
          </Navbar>

          {!this.state.isAgentListPage && (
            <div className="contentSwitch">
              <button
                type="button"
                className="btn btn-link btn-link${this.props.theme} btn-lg"
                style={{
                  padding: "0px",
                  outline: "none",
                  textDecoration: "none",
                }}
                onClick={this.toggleContent}
              >
                <span
                  className={`icon icon-align-left when-not-active ${
                    this.state.selectedContent === PANELS
                      ? "showContent"
                      : "hideContent"
                  }`}
                ></span>
                <span
                  className={`icon icon-align-right when-active ${
                    this.state.selectedContent === BROWSER
                      ? "showContent"
                      : "hideContent"
                  }`}
                ></span>
              </button>
            </div>
          )}

          {!this.state.isAgentListPage && (
            <div className="container-fluid">
              <div
                className={`row row-offcanvas row-offcanvas-right full-screenable ${
                  this.state.fullScreen ? "full-screened" : ""
                }`}
              >
                <div
                  className={`col-xs-12 col-md-8 col-lg-9 full-height full-screen-main ${
                    this.state.selectedContent === BROWSER
                      ? "showContent"
                      : "hideContent"
                  }`}
                >
                  <p className="hidden-xs visible-lg visible-md tabs-toggle-button full-screen-button">
                    <button
                      style={{ padding: "10px 9px" }}
                      type="button"
                      className={`btn btn-link btn-link${this.props.theme} btn-lg`}
                      data-toggle="fullscreen"
                      onClick={this.fullScreenToggle}
                    >
                      <span className="icon icon-resize-full-screen when-not-fullscreen"></span>
                      <span className="icon icon-resize-100 when-fullscreen"></span>
                    </button>
                  </p>

                  <TabMenu />
                  {/* <PhoneFooter /> */}
                  {/* <div className="pane-footer">
                <img src="img/logo-branded.svg" alt="powered by Numintec" />
                &copy; 2016
              </div> */}
                </div>
                <div
                  className={`col-xs-6 col-md-4 col-lg-3 sidebar-offcanvas full-height ${
                    onGoingCalls.length > 0 ? "hasRuntime" : ""
                  } ${
                    this.state.selectedContent === PANELS
                      ? "showContent"
                      : "hideContent"
                  }`}
                  id="sidebar"
                >
                  {this.state.panels_display &&
                    !this.state.panels_display.web_phone &&
                    onGoingCalls.length > 0 && <Runtime />}
                  {this.panelOrder()}
                </div>
              </div>
            </div>
          )}
         
          {this.state.isAgentListPage && (
            <AgentsMonitor
              searchFilter={this.state.agentSearch}
              activeMonitorView={this.state.activeMonitorView}
            />
          )}
          <Notifications
            callData={onGoingCallData}
            callTerminate={callTerminate}
            callTerminateTime={callTerminateTime}
          /> 
          
          
          
          <AskForService
            showModal={this.state.showAskForServiceModal}
            payload={this.state.payload}
            handleClose={() => this.close("showAskForServiceModal")}
          />
        </article>
         
        {!agentInfo.agent_id && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
            }}
          >
            <Loader />
          </div>
        )}
      </div>
    );
  };
}

function mapStateToProps(state) {
  return {
    agentInfo: state.agentInfo,
    agentConfig: state.agentConfig,
    globalLoading: state.globalLoading,
    callAvailable: state.availability.callAvailable,
    translations: state.languages.translations,
    selectedLanguage: state.languages.selectedLanguage,
    reopenTab: state.callEvents.reopenTab,
    activeTabs: state.callEvents.events,
    callUrlData: state.callEvents.callUrlData,
    onGoingCalls: state.runtime.onGoingCalls,
    queuedCalls: state.queuedCalls.queuedCalls,
    agents: state.agentsAndSupervisors.agents,
    supervisors: state.agentsAndSupervisors.supervisors,
    serviceList: state.agentsAndSupervisors.serviceList,
    logoutComplete: state.logout.logoutComplete,
    doCall: state.callEvents.doCall,
    phonePayload: state.callEvents.phonePayload,
    currentOutgoingCalls: state.browserTabs.calls,
    logo: state.common.logo,
    agentsOnCallList: state.agentsAndSupervisors.agentsOnCallList,
    incomingCallsList: state.incomingCallsList.calls,
    darkMode: state.common.darkMode,
    theme: state.common.theme,
    themecode: state.common.themecode,
    showInvalidAudioSettingsMessage: state.common.showInvalidAudioSettingsMessage
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getAgentConfigAndInfo,
      changeLang,
      getAgentInfo,
      setDefaultService,
      addCallEvent,
      outgoingTerminated,
      incomingTerminated,
      incomingMissed,
      queueCallJoin,
      queueCallLeave,
      queueCallNoAnswer,
      modifyQueueCalls,
      getIncomingCalls,
      getOutgoingCalls,
      getQueuedCalls,
      getAuotoDialerCalls,
      getAgentTokenData,
      getCallUrl,
      getAgents,
      getAllAgents,
      updateAgentsCallAvailability,
          getSupervisors,
      agentOnCall,
      agentOnCallAnswered,
      agentCallTerminated,
      getAvailabilityList,
          setCallAvailability,
          changeDefaultAvailability,
      setOnline,
      getServicesListByAgent,
      fullScreenChange,
      callStarted,
      callAnswered,
      closeMenuPopup,
      makeOutgoingCall,
      resetCall,
      setTabLock,
      slackNotification,
      doLogout,
      addOutgoingCall,
      removeOutgoingCall,
      updateOutgoingCall,
      deleteCallEvent,
      setResetActiveTab,
      getCustomLogo,
      setAgentsOnCallList,
      addIncomingCall,
      removeIncomingCall,
      setCallUrlData,
      deleteCallEvents,
      setAgentConfigData,
      setAudioSettings,
      set_thememode,
      set_theme,
      get_theme,
      set_themecode,
      getOmniUrl,
      setAgentPermission,
      removeNotification,
      notificationOpened,
      showWebphone,
      set_showInvalidAudioSettingsMessage
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/agent/App.js